import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { doFetchJiraServerLabels } from 'ducks/integrations/jiraServer'
import {
  selectJiraAreLabelsLoading,
  selectJiraLabelsByQuery,
} from 'ducks/integrations/jiraShared'
import ValidatedField from 'shared/components/ui/ValidatedField'
import { Label } from 'shared/ui'
import { Dropdown } from 'util/ui'

import FormRow from 'components/App/DesktopView/Layout/RightSidebar/InAppCards/shared/LinkResource/FormRow'
import OptionalLabel from 'components/App/DesktopView/Layout/RightSidebar/InAppCards/shared/LinkResource/OptionalLabel'

export default connect(
  state => ({
    areLabelsLoading: selectJiraAreLabelsLoading(state, {
      source: 'jiraServer',
    }),
    labels: selectJiraLabelsByQuery(state, { source: 'jiraServer' }),
  }),
  { doFetchJiraServerLabels }
)(LabelsFormField)

function search(results) {
  return results
}

function LabelsFormField({
  areLabelsLoading,
  doFetchJiraServerLabels: fetchLabels,
  formFields: { label = [] },
  isProjectChoosen,
  labels,
  onChange: propOnChange,
}) {
  const [labelSearch, setLabelSearch] = useState('')
  const onSearchChange = useCallback(
    (_, { searchQuery }) => {
      return setLabelSearch(searchQuery)
    },
    [setLabelSearch]
  )
  useEffect(
    () => {
      fetchLabels(labelSearch)
    },
    [fetchLabels, labelSearch]
  )
  const onChange = useCallback(
    (...args) => {
      const { searchQuery } = args[1]
      propOnChange(...args)
      setLabelSearch(searchQuery || '')
    },
    [propOnChange, setLabelSearch]
  )
  return (
    <FormRow>
      <Label as="div">
        Labels <OptionalLabel>(optional)</OptionalLabel>
      </Label>
      <ValidatedField
        additionLabel=""
        allowAdditions
        disabled={!isProjectChoosen}
        fluid
        loading={areLabelsLoading}
        multiple
        noResultsMessage={areLabelsLoading ? 'Loading...' : 'No results found.'}
        name="label"
        options={[...(labels[labelSearch] || []), ...label].map(l => ({
          text: l,
          value: l,
        }))}
        onChange={onChange}
        onSearchChange={onSearchChange}
        placeholder={areLabelsLoading ? 'Loading...' : '- Please select -'}
        search={search}
        selection
        selectOnNavigation={false}
        validatedFieldComponent={Dropdown}
        value={label}
      />
    </FormRow>
  )
}
